/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const PencilIcon = createIcon(
  '0 0 20 20',
  <path d="M6 18 16 7.884a2.885 2.885 0 0 0 0-4.046 2.806 2.806 0 0 0-4 0L2 13.954V18zm12-2.023h-7L9 18h9z" />,
);
